import type { NotebookNote } from '../../../shared/types/notebook'

interface DragOverlayRowProps {
  note: NotebookNote
}

export default function DragOverlayRow({ note }: DragOverlayRowProps) {
  return (
    <div
      className="flex items-center gap-2.5 px-3 py-2.5 rounded-lg bg-charcoal/95 border border-gold/30 shadow-xl backdrop-blur-sm opacity-90"
      style={{ transform: 'scale(0.98)' }}
    >
      <span className="text-base flex-shrink-0">{note.icon}</span>
      <span className="text-ivory text-sm truncate">{note.title || 'Untitled'}</span>
    </div>
  )
}
